import {fieldValidator, formDataFBuilder} from "../common";
import {showModal, notice} from "../messages";
import {Validator} from '../validator';

export const init = events => new Comment(events);

export default class Comment {
    constructor(events) {
        this.events = events;
        let $this = this;
        let required_field_flag;
        document.querySelectorAll('.js_modal_comment_form input, .js_modal_comment_form textarea').forEach(item => {
            item.addEventListener('input', event => {
                event.preventDefault()
                event.stopPropagation()
                clearTimeout(required_field_flag);
                required_field_flag = setTimeout(()=>{
                    return fieldValidator(item)
                }, 1000);

                let button = event.currentTarget.closest('form').querySelector('.js_add_comment');
                if (button) {
                    button.disabled = false;
                }
            })
        });

        document.querySelectorAll('.js_add_comment').forEach(item => {
            item.addEventListener('click', event => {
                event.stopPropagation();
                event.preventDefault();
                event.currentTarget.disabled = true;
                $this.addComment(item.closest('form'))
            })
        })
    }

    createComment(page) {
        showModal(`<div class="main-modal">
                            <div class="main-login reviews-modal">
                                <div class="main-login-block">
                                    <div class="main-login-block-heading">Отзыв</div>
                                    <form class="js_modal_comment_form">
                                        <input type="hidden" name="page" value="${page}">
                                        <div class="rating reviews-block-item-comment-block-rating mb-3" data-score="4"></div>
                                        <div class="row">
                                            <div class="col-sm-12 mb-3">
                                                <div class="main-login-block-name mb-2">Ваше имя</div>
                                                <input class="main-input w-100" type="text" name="name" title="Введите имя"  placeholder="Ваше имя" required>
                                            </div>
                                        </div>
                                        <span class="main-login-block-name">Введите ваш отзыв</span>
                                        <div class="main-login-block-input">
                                            <textarea class="main-input w-100" 
                                                        name="text" cols="30" 
                                                        rows="6" 
                                                        placeholder="Комментарий"
                                                         required
                                            >
                                                      
                                            </textarea>
                                        </div>
                                        <button class="btn btn-green js_add_comment" type="submit" title="Оставить отзыв">Написать</button>
                                    </form>
                                </div>
                         
                            </div>
                        </div>`);
    }

    addComment(form) {
        let hasError = false;
        let data = {};
        form.querySelectorAll('input, textarea').forEach(item => {
            if (!Validator.notBlank(item)) {
                hasError = true;
                item.classList.add('is-invalid')
                item.classList.remove('is-valid')
            } else {
                item.classList.add('is-valid')
                item.classList.remove('is-invalid')
            }
        })

        if (!hasError) {
            const formData = formDataFBuilder(form);
            data.action = 'addComment';
            (async () => {
                try {
                    form.classList.add("preloader");
                    let response = await fetch(form.getAttribute('action'), {
                        mode: 'cors',
                        method: 'POST',
                        body: formData
                    });
                    let resultResponse = await response.json();
                    notice(resultResponse.message, !resultResponse.success)
                    if(resultResponse.success){
                        form.reset();
                        form.querySelectorAll('input, textarea').forEach(item => {
                            item.classList.remove('is-invalid')
                            item.classList.remove('is-valid')
                        })
                    }
                } catch (e) {
                    notice('Ошибка при обновлении данных', true)
                } finally {
                    form.classList.remove("preloader");
                }
            })();
        }
    }
}